import { APPOINTMENT_STATUS_COLORS, categoryColor } from "../constants";

export function categoryNames(ids = [], categories = []) {
  return ids
    .map((id) => categories.find((category) => category.serviceCategoryId === id)?.name || id)
    .filter(Boolean)
    .join(", ");
}

export function buildCalendarEvents({
  availability = [],
  blocks = [],
  appointments = [],
  holds = [],
  categories = [],
  practitionerNames = {},
  showBookings = true,
  titlePrefix = false,
}) {
  const events = [];

  availability.forEach((window) => {
    const names = categoryNames(window.serviceCategoryIds, categories);
    const prefix = titlePrefix ? `${practitionerNames[window.scheduleId] || practitionerNames[window.practitionerRef] || "NP"} · ` : "";
    events.push({
      id: `availability-${window.availabilityId}`,
      title: `${prefix}${names || "Available"}`,
      start: window.startsAt,
      end: window.endsAt,
      backgroundColor: categoryColor(window.serviceCategoryIds?.[0]),
      borderColor: categoryColor(window.serviceCategoryIds?.[0]),
      extendedProps: { kind: "availability", source: window },
    });
  });

  blocks.forEach((block) => {
    const prefix = titlePrefix ? `${practitionerNames[block.scheduleId] || practitionerNames[block.practitionerRef] || "NP"} · ` : "";
    events.push({
      id: `block-${block.blockId}`,
      title: `${prefix}${block.reasonCode || "Block"}`,
      start: block.startsAt,
      end: block.endsAt,
      backgroundColor: "#9e9e9e",
      borderColor: "#757575",
      classNames: ["scheduling-event-block"],
      extendedProps: { kind: "block", source: block },
    });
  });

  if (showBookings) {
    appointments.forEach((appointment) => {
      const categoryName = categoryNames([appointment.serviceCategoryId], categories);
      const prefix = titlePrefix
        ? `${practitionerNames[appointment.scheduleIds?.[0]] || practitionerNames[appointment.practitionerRefs?.[0]] || "NP"} · `
        : "";
      events.push({
        id: `appointment-${appointment.appointmentId}`,
        title: `${prefix}${categoryName || "Appointment"}`,
        start: appointment.startsAt,
        end: appointment.endsAt,
        backgroundColor: APPOINTMENT_STATUS_COLORS[appointment.status] || "#1976d2",
        borderColor: APPOINTMENT_STATUS_COLORS[appointment.status] || "#1976d2",
        extendedProps: { kind: "appointment", source: appointment },
      });
    });
  }

  holds.forEach((hold) => {
    if (hold.status !== "active") return;
    events.push({
      id: `hold-${hold.holdId}`,
      title: "Hold",
      start: hold.startsAt,
      end: hold.endsAt,
      backgroundColor: "#fff",
      borderColor: "#005da8",
      display: "block",
      extendedProps: { kind: "hold", source: hold },
    });
  });

  return events;
}
